export default "__VITE_ASSET__6bTekH_b__"